/**
 * Email Service — calls the Resend-backed API
 * Templates and sending live on the API (api/send-invitation.js).
 */

const getApiUrl = () => import.meta.env.VITE_API_URL || 'https://api.tanzaniabasketball.com';

async function postEmail(path, body) {
  const response = await fetch(`${getApiUrl()}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData.error || `Failed to send email (${path})`);
  }

  return response.json();
}

/**
 * Send account-created / invitation email
 */
export const sendInvitationEmail = async ({ to, fullName, email, password, role, loginUrl }) => {
  try {
    const result = await postEmail('/send-invitation', {
      to,
      fullName,
      email,
      password,
      role,
      loginUrl: loginUrl || `${window.location.origin}/login`,
    });
    console.log('Invitation email sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send invitation email: ${error.message}`);
  }
};

/**
 * Send account / profile update notification email
 */
export const sendProfileUpdateEmail = async ({ to, fullName, changes }) => {
  try {
    const result = await postEmail('/send-profile-update', {
      to,
      fullName,
      changes,
    });
    console.log('Profile update email sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send profile update email: ${error.message}`);
  }
};

/**
 * Send regional association / profile created confirmation
 */
export const sendRegionalProfileCreatedEmail = async ({
  to,
  associationName,
  region,
  email,
  mobile,
  registrationNumber,
  chairpersonName,
  secretaryName,
  portalUrl,
}) => {
  try {
    const result = await postEmail('/send-regional-profile-created', {
      to,
      associationName,
      region,
      email,
      mobile,
      registrationNumber,
      chairpersonName,
      secretaryName,
      portalUrl: portalUrl || `${window.location.origin}/regions`,
    });
    console.log('Regional profile email sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send regional profile email: ${error.message}`);
  }
};

/**
 * Send password reset email
 */
export const sendPasswordResetEmail = async ({ to, fullName, resetUrl }) => {
  try {
    const result = await postEmail('/send-password-reset', {
      to,
      fullName,
      resetUrl,
    });
    console.log('Password reset email sent successfully:', result);
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send password reset email: ${error.message}`);
  }
};

export const sendCoachRegistrationInviteEmail = async ({
  to,
  coachName,
  registrationUrl,
  expiresAt,
}) => {
  try {
    const result = await postEmail('/send-coach-registration-invite', {
      to,
      coachName,
      registrationUrl,
      expiresAt,
    });
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send coach registration invite: ${error.message}`);
  }
};

export const sendCoachRegistrationSubmittedEmail = async ({ to, coachName, coachData }) => {
  try {
    const result = await postEmail('/send-coach-registration-submitted', {
      to,
      coachName,
      coachData,
    });
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send coach registration confirmation: ${error.message}`);
  }
};

export const sendCoachStatusNotificationEmail = async ({ to, coachName, action, coachData }) => {
  try {
    const result = await postEmail('/send-coach-status-notification', {
      to,
      coachName,
      action,
      coachData,
    });
    return result;
  } catch (error) {
    console.error('Email sending failed:', error.message);
    throw new Error(`Failed to send coach status notification: ${error.message}`);
  }
};

export default {
  sendInvitationEmail,
  sendProfileUpdateEmail,
  sendRegionalProfileCreatedEmail,
  sendPasswordResetEmail,
  sendCoachRegistrationInviteEmail,
  sendCoachRegistrationSubmittedEmail,
  sendCoachStatusNotificationEmail,
};
